import React from 'react'
import { pick, isEmpty, pathOr } from 'ramda'
import moment from 'moment'
import { Avatar, TextLoader, Div, Span, A, H3 } from '@driftt/tide-core'
import { Icon } from '@driftt/tide-icons'
import SalesforceSection from './SalesforceSection'
import HubSpotSection from './HubSpotSection'
import Config from 'config'

const LINKEDIN_MODULES_TO_RENDER = Object.freeze(['IceBreakers', 'GetIntroduced', 'RelatedLeads'])

const renderContactProperties = (value, i) => {
  return (
    <Div className="contacts-contact-sidebar--details--about-field" key={`contacts-contact-sidebar--details--property-${i}`}>
      <Div className="field-header">
        {value[0].toLowerCase()}
      </Div>
      <Div className="field-value">
        {value[1] ? value[1] : 'unknown'}
      </Div>
    </Div>
  )
}

const renderSegmentInformation = (segment, i) => {
  return (
    <Div className="contacts-contact-sidebar--details--segments-info-item" key={`contacts-contact-sidebar--details--segment-${i}`}>
      <Div className="segment-link">
        <A href={`/contacts/segments/${segment.id}`}>{segment.name}</A>
      </Div>
      <Div className="segment-update">
        {`updated ${moment(segment.updatedAt).fromNow()}`}
      </Div>
    </Div>
  )
}

const renderSocialProfile = (profile, i) => {
  return (
    <Div key={`${profile}-${i}`}></Div>
  )
}

const ContactSidebarDetails = ({ contact, segments, connectedIntegrations, orgId }) => {
  const { LINKEDIN_KEY } = Config
  const aboutFields = pick(['name', 'email', 'timeZone', 'locale'], contact)

  const { socialProfile, attributes } = contact

  const { _classification } = attributes

  const aboutArea = Object.entries(aboutFields).map(renderContactProperties)

  const socialArea = !isEmpty(socialProfile) ? Object.entries(socialProfile).map(renderSocialProfile) : null

  const sfdcArea = !!connectedIntegrations['salesforce'] ?
    <SalesforceSection email={ aboutFields.email } /> :
    null
  
  const hubspotArea = !!connectedIntegrations['hubspot'] ?
    <HubSpotSection email={ aboutFields.email } /> :
    null
  
  return (
    <Div className="contacts-contact-sidebar--details">
      <Div className="contacts-contact-sidebar--details--basic">
        <Div className="contact-avatar">
          <Avatar user={contact} type="user" />
        </Div>
        <Div className="contact-details--basic">
          <H3>{aboutFields.name ? aboutFields.name : aboutFields.email}</H3>
          <Span><Icon name="location-2" width={10} />{ aboutFields.locale ? aboutFields.locale : `Could not locate`}</Span>
          <Span>{!isEmpty(socialProfile) ? renderSocialProfile(socialProfile) : null}</Span>
        </Div>
      </Div>
      {connectedIntegrations.linkedin && 
        <Div className="contacts-contact-sidebar--details--linkedin">
          <Div className="contacts-contact-sidebar--details--about-header">
            <Icon name="rolodex" width={15}/>
            <Span>LINKEDIN SALES NAVIGATOR</Span>
          </Div>
          <Div className="contacts-contact-sidebar--details--about-field">
            <iframe
              src={`https://www.linkedin.com/sales/widget/profile-matching?apiKey=${LINKEDIN_KEY}&profile=lead&firstName=${pathOr('', ['attributes', 'first_name'], contact)}&lastName=${pathOr('', ['attributes', 'last_name'], contact)}&email=${contact.email}&companyName=${pathOr('', ['attributes', 'employment_name'], contact)}&crmRecordId=${contact.id}&crmOrgId=${orgId}&crmSourceType=DRIFT&modules=${LINKEDIN_MODULES_TO_RENDER.join(',')}&version=2.0.0&isInlineMode=false`}
              width={'100%'}
              height={352}
              title="Sidebar Sales Navigator"
              id="developer-specified-ID"
              frameBorder="0"
              type="text/html"
            />
          </Div>
        </Div>
      }
      <Div className="contacts-contact-sidebar--details--about">
        <Div className="contacts-contact-sidebar--details--about-header">
          <Icon name="rolodex" width={15}/>
          <Span>ABOUT</Span>
        </Div>
        {aboutArea}
        {socialArea}
        <Div className="contacts-contact-sidebar--details--about-field">
          <Div className="field-header">lead stage</Div>
          <Div className="field-value">{_classification ? _classification : 'N/A'}</Div>
        </Div>
      </Div>
      {sfdcArea}
      {hubspotArea}
      <Div className="contacts-contact-sidebar--details--segments">
        <Div className="contacts-contact-sidebar--details--segments-header">
          <Icon name="donut-chart-2" width={15}/>
          <Span>SEGMENTS</Span>
        </Div>
        <Div className="contacts-contact-sidebar--details--segments-info">
            {!segments && <TextLoader text="Grabbing segment information"/>}
            {!!segments && segments.map(renderSegmentInformation)}
          </Div>
      </Div>
    </Div>
  )
}

export default ContactSidebarDetails
